import type { FC } from 'react';

import type { MilestonePeriodData } from './milestone-period';
import MilestonePeriod from './milestone-period';

export interface MilestoneCollectionProps {
  defaultMileStonePeriods?: MilestonePeriodData[];
  milestonePeriods?: MilestonePeriodData[];
  onMissionDetails?: (id: string) => void;
}

export const MilestoneCollection: FC<MilestoneCollectionProps> = ({
  milestonePeriods,
  onMissionDetails,
  defaultMileStonePeriods,
}) => {
  const getMilestonePeriodRecord = ({
    endTime,
    periodType,
    endPoint,
    title,
    imgUrl,
    currencyType,
    id,
    description,
    isClaimed,
    milestoneId,
    hasPin,
    currentPoint,
    updatedAt,
    quantity,
  }: MilestonePeriodData) => (
    <MilestonePeriod
      data={{
        currencyType,
        currentPoint,
        description,
        endPoint,
        endTime,
        id,
        imgUrl,
        isClaimed,
        milestoneId,
        periodType,
        title,
        hasPin,
        updatedAt,
        quantity,
      }}
      key={id}
      onClick={() => onMissionDetails?.(id)}
      onReset={() => {}}
    />
  );

  return (
    <>
      <div className="3xl:grid-cols-5 grid grid-cols-2 gap-12 md:grid-cols-3">
        {defaultMileStonePeriods?.length
          ? defaultMileStonePeriods.map(getMilestonePeriodRecord)
          : null}
      </div>
      {milestonePeriods && Boolean(milestonePeriods.length) && (
        <div className="3xl:grid-cols-5 grid grid-cols-2 gap-12 pt-12 md:grid-cols-3">
          {milestonePeriods.map(getMilestonePeriodRecord)}
        </div>
      )}
    </>
  );
};
